import { makeEnvironmentProviders, type EnvironmentProviders } from '@angular/core';
import { provideStates } from '@ngxs/store';
import { SessionServiceClientProvider } from '@camino-solutions/share/proto/client-provider';
import { SessionState } from './session.state';

export function provideSessionState(): EnvironmentProviders {
  return makeEnvironmentProviders([provideStates([SessionState]), ...SessionServiceClientProvider]);
}
